module.exports = __webpack_public_path__ + "img/diamond.e50d8351.jpg";